<div class="row" id="AcRow" *ngIf="showActivityUI">
  <div class="col-md-12" id="AcCol">
    <mat-card appearance="outlined" class="marB16" id="AcMatCard">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true" id="AcBtn">
          <mat-icon class="close-icon" color="warn" id="AcIcon">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16" id="AcActivity">
            {{ correspondenceDataObj.activityName }}
          </h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft" id="AcUser">{{ loginUserName || 'NA' | initials }}</span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16" id="AcLogin">{{ loginUserName }}</h5>
          <span class="float-right marT4">
            <span
              class="marginicon40 mainBodyTxt3 GreyLight blockInfo"
              *ngIf="timeModifiedOn; else elseTemplate"
              id="AcDate"
            >
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate id="AcTemp"> </ng-template>
          </span>
        </div>
      </div>
      <mat-card-content *ngIf="isCollapsed" [ngClass]="{ readActivityDisable: data && data.readflag }">
        <form name="correpForm" #f="ngForm" id="AcForm">
          <div *ngIf="this.testformValid(!f.invalid)"></div>
          <mat-form-field style="width: 25%">
            <mat-label>Template</mat-label>
            <mat-select
              required
              name="template"
              [(ngModel)]="selectedTemplate"
              (ngModelChange)="getTemplateData($event)"
              [disabled]="templateDisable"
            >
              <mat-option *ngFor="let status of templateData" [value]="status.templateId" class="custom-select-option">
                {{ status.templateName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="row">
            <div class="col-md-10">
              <mat-form-field class="custom-form-field">
                <input
                  #toValue
                  matInput
                  placeholder="To"
                  required
                  name="toInput"
                  [value]=""
                  [disabled]="toDisable"
                  (input)="toInputValue = $event.target.value"
                  [(ngModel)]="toInputValue"
                />
              </mat-form-field>
            </div>
            <button mat-icon-button class="text-btn" name="ccbtn" (click)="ccEnableDisable()" style="font-size: 16px">
              CC
            </button>
            <button mat-icon-button class="text-btn" name="bccbtn" (click)="bccEnableDisable()" style="font-size: 16px">
              BCC
            </button>
          </div>

          <mat-form-field class="custom-form-field" [ngStyle]="{ visibility: ccEnable ? 'visible' : 'hidden' }">
            <input
              #ccValue
              matInput
              placeholder="CC"
              name="ccinput"
              [value]=""
              [(ngModel)]="ccInputValue"
              (input)="ccInputValue = $event.target.value"
            />
          </mat-form-field>

          <mat-form-field class="custom-form-field" [ngStyle]="{ visibility: bccEnable ? 'visible' : 'hidden' }">
            <input
              #bccValue
              matInput
              placeholder="BCC"
              name="bccinput"
              [value]=""
              [(ngModel)]="bccInputValue"
              (input)="bccInputValue = $event.target.value"
            />
          </mat-form-field>

          <mat-form-field class="custom-form-field">
            <input
              #subjectValue
              matInput
              placeholder="Subject"
              required
              name="subjectinput"
              [value]=""
              (input)="subjectInputValue = $event.target.value"
              [(ngModel)]="subjectInputValue"
            />
          </mat-form-field>

          <mat-form-field class="custom-form-field">
            <textarea
              #bodyValue
              matInput
              rows="10"
              placeholder="Body"
              required
              name="bodyinput"
              (input)="bodyInputValue = $event.target.value"
              [(ngModel)]="bodyInputValue"
            ></textarea>
          </mat-form-field>
          <!-- {{correspondenceDataObj.correspondenceActivity.comments}} -->
          <mat-form-field class="custom-form-field">
            <input
              matInput
              [(ngModel)]="remarksInputValue"
              name="remarksinput"
              #remarksValue
              placeholder="Remarks"
              value=""
              (input)="remarksInputValue = $event.target.value"
            />
          </mat-form-field>

          <mat-card appearance="outlined">
            <app-attachment
              (fileOutput)="receiveFileOutput($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              activityModuleFlag="true"
            ></app-attachment>
          </mat-card>

          <div class="row" *ngIf="!ifCoupled">
            <div class="col-md-2" *ngIf="!interviewFlag">
              <div class="row nomarLR padTB16">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  [disabled]="setDisabled(f.invalid) || !f.dirty"
                  type="submit"
                  name="sendbtn"
                  (click)="send()"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction m-auto">
        <div>
          <a
            href="javascript:void(0)"
            id="collapseAction"
            [ngClass]="isCollapsed ? 'icon x-24 up-arw-icon' : 'icon x-24 down-arw-icon'"
            (click)="showMoreLess()"
          ></a>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
